import { render, staticRenderFns } from "./payment_follow_ups_count.vue?vue&type=template&id=208f04c2&"
import script from "./payment_follow_ups_count.vue?vue&type=script&lang=js&"
export * from "./payment_follow_ups_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports